import {
  GET_OPERATION_LOG_DATA_SUCCESS, GET_USER_OPERATION_LIST_DATA, GET_DEAL_OPERATION_LIST_DATA,
  GET_API_OPERATION_LIST_DATA, GET_REPORT_OPERATION_LIST_DATA, GET_USER_OPERATION_LIST_DATA_SUCCESS,
  GET_EMAIL_OPERATION_LIST_DATA, GET_EMAIL_OPERATION_LIST_DATA_SUCCESS, GET_DEAL_OPERATION_LIST_DATA_SUCCESS,
  GET_API_OPERATION_LIST_DATA_SUCCESS, GET_REPORT_OPERATION_LIST_DATA_SUCCESS, GET_ERROR_MESSAGE_LIST_DATA,
  GET_ERROR_MESSAGE_LIST_DATA_SUCCESS, GET_API_OPERATION_DATA_SUCCESS, RESET_OPERATION_LOG_DATA,
  RESET_OPERATION_LOG_FILE_LINK, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../../constants/system/actions';

const settingsOperationLogReducer: Reducer = (
  state: ReducerState = {
    operationLogData: null,
    fileLink: null,
    isLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_OPERATION_LOG_DATA_SUCCESS:
      return {
        ...state,
        operationLogData: action.data,
        isLoading: false,
      };
    case GET_USER_OPERATION_LIST_DATA:
    case GET_EMAIL_OPERATION_LIST_DATA:
    case GET_DEAL_OPERATION_LIST_DATA:
    case GET_API_OPERATION_LIST_DATA:
    case GET_REPORT_OPERATION_LIST_DATA:
    case GET_ERROR_MESSAGE_LIST_DATA:
      return {
        ...state,
        isLoading: !!action.payload && !!action.payload.page,
      };
    case GET_USER_OPERATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            userOperationList: [...state.operationLogData.userOperationList, ...action.data.userOperationList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          userOperationList: action.data.userOperationList,
          userOperationsTotal: action.data.userOperationsTotal,
        },
        isLoading: false,
      };
    case GET_EMAIL_OPERATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            emailOperationList: [...state.operationLogData.emailOperationList, ...action.data.emailOperationList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          emailOperationList: action.data.emailOperationList,
          emailOperationsTotal: action.data.emailOperationsTotal,
        },
        isLoading: false,
      };
    case GET_DEAL_OPERATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            dealOperationList: [...state.operationLogData.dealOperationList, ...action.data.dealOperationList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          dealOperationList: action.data.dealOperationList,
          dealOperationsTotal: action.data.dealOperationsTotal,
        },
        isLoading: false,
      };
    case GET_API_OPERATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            apiOperationList: [...state.operationLogData.apiOperationList, ...action.data.apiOperationList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          apiOperationList: action.data.apiOperationList,
          apiOperationsTotal: action.data.apiOperationsTotal,
        },
        isLoading: false,
      };
    case GET_REPORT_OPERATION_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            reportOperationList: [...state.operationLogData.reportOperationList, ...action.data.reportOperationList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          reportOperationList: action.data.reportOperationList,
          reportOperationsTotal: action.data.reportOperationsTotal,
        },
        isLoading: false,
      };
    case GET_ERROR_MESSAGE_LIST_DATA_SUCCESS:
      if (action.payload && action.payload.page) {
        return {
          ...state,
          operationLogData: {
            ...state.operationLogData,
            errorMessageList: [...state.operationLogData.errorMessageList, ...action.data.errorMessageList],
          },
          isLoading: false,
        };
      }

      return {
        ...state,
        operationLogData: {
          ...state.operationLogData,
          errorMessageList: action.data.errorMessageList,
          errorMessagesTotal: action.data.errorMessagesTotal,
        },
        isLoading: false,
      };
    case GET_API_OPERATION_DATA_SUCCESS:
      return {
        ...state,
        fileLink: action.data.responseFileLink,
      };
    case RESET_OPERATION_LOG_DATA:
      return {
        ...state,
        operationLogData: null,
        fileLink: null,
        isLoading: false,
      };
    case RESET_OPERATION_LOG_FILE_LINK:
      return {
        ...state,
        fileLink: null,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        operationLogData: null,
        fileLink: null,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default settingsOperationLogReducer;
